// @ts-nocheck

const grey = Object.freeze({
  bluegrey950: '#0A0B0F',
  bluegrey925: '#0F1118',
  bluegrey900: '#14171F',
  bluegrey850: '#1F222E',
  bluegrey800: '#292e3d',
  bluegrey750: '#33394d',
  bluegrey700: '#3d455c',
  bluegrey650: '#47506b',
  bluegrey600: '#525c7a',
  bluegrey550: '#5c678a',
  bluegrey500: '#667399',
  bluegrey450: '#7581a3',
  bluegrey400: '#858fad',
  bluegrey350: '#949db8',
  bluegrey300: '#a3abc2',
  bluegrey250: '#b3b9cc',
  bluegrey200: '#c2c7d6',
  bluegrey150: '#d1d5e0',
  bluegrey100: '#e0e3eb',
  bluegrey50: '#f0f1f5',

  neutralgrey950: '#0d0d0d',
  neutralgrey900: '#1a1a1a',
  neutralgrey850: '#262626',
  neutralgrey800: '#333333',
  neutralgrey750: '#404040',
  neutralgrey700: '#4d4d4d',
  neutralgrey650: '#595959',
  neutralgrey600: '#666666',
  neutralgrey550: '#737373',
  neutralgrey500: '#808080',
  neutralgrey450: '#8c8c8c',
  neutralgrey400: '#999999',
  neutralgrey350: '#a6a6a6',
  neutralgrey300: '#b3b3b3',
  neutralgrey250: '#bfbfbf',
  neutralgrey200: '#cccccc',
  neutralgrey150: '#d9d9d9',
  neutralgrey100: '#e6e6e6',
  neutralgrey50: '#f2f2f2',
});

const silver = Object.freeze({
  silver600: '#597bc0',
  silver400: '#b3e5e5',
  silver340: '#a5a9be',
  silver300: '#adadc3',
  silver200: '#cbcddd',
  silver75: '#ecf9f9',
  silver50: '#eff1f7',
});

const gold = Object.freeze({
  gold500: '#a64b00',
  gold385: '#cb931a',
  gold375: '#db9100',
  gold350: '#d87000',
  gold250: '#fedf80',
  gold225: '#ff8500',
  gold200: '#ffbd29',
  gold150: '#ffd27b',
  gold75: '#ffefb7',
  gold50: '#fff3d9',
});

const green = Object.freeze({
  // todo
  greenwin: '#10ed40', // Step 3 pour les percent distribution

  greenwinamax950: '#05140d',
  greenwinamax900: '#0a2919',
  greenwinamax850: '#0f3d26',
  greenwinamax800: '#145233',
  greenwinamax750: '#196640',
  greenwinamax700: '#1f7a4c',
  greenwinamax650: '#248f59',
  greenwinamax600: '#29a366',
  greenwinamax550: '#2eb873',
  greenwinamax500: '#33cc7f',
  greenwinamax450: '#47d18c',
  greenwinamax400: '#5cd699',
  greenwinamax350: '#70dba6',
  greenwinamax300: '#85e1b3',
  greenwinamax250: '#99e5bf',
  greenwinamax200: '#adebcc',
  greenwinamax150: '#c2f0d9',
  greenwinamax100: '#d7f5e6',
  greenwinamax50: '#eafaf2',
});

const yellow = Object.freeze({
  yellowwinamax950: '#1a1300',
  yellowwinamax900: '#332600',
  yellowwinamax850: '#4d3900',
  yellowwinamax800: '#664d00',
  yellowwinamax750: '#806000',
  yellowwinamax700: '#997300',
  yellowwinamax650: '#b28600',
  yellowwinamax600: '#cc9900',
  yellowwinamax550: '#e5ac00',
  yellowwinamax500: '#ffbf00',
  yellowwinamax450: '#ffc61a',
  yellowwinamax400: '#ffcc33',
  yellowwinamax350: '#ffd24c',
  yellowwinamax300: '#ffd967',
  yellowwinamax250: '#ffdf80',
  yellowwinamax200: '#ffe599',
  yellowwinamax150: '#ffecb3',
  yellowwinamax100: '#fff3cd',
  yellowwinamax50: '#fff9e5',

  yellowinfo900: '#26200D',
  yellowinfo200: '#F0DEA8',
});

const orange = Object.freeze({
  orange100: '#ff6700',
});

const red = Object.freeze({
  red100: '#ff494c',
  red200: '#e50914',
  red650: '#b20e10',
  red775: '#6e1e20',

  redwinamax950: '#180101',
  redwinamax900: '#300303',
  redwinamax850: '#490404',
  redwinamax800: '#610505',
  redwinamax750: '#790606',
  redwinamax700: '#910808',
  redwinamax650: '#aa0909',
  redwinamax600: '#c20a0a',
  redwinamax550: '#da0b0b',
  redwinamax500: '#f20d0d',
  redwinamax450: '#f42525',
  redwinamax400: '#f53d3d',
  redwinamax350: '#f65555',
  redwinamax300: '#f76f6f',
  redwinamax250: '#f98686',
  redwinamax200: '#fa9e9e',
  redwinamax150: '#fbb7b7',
  redwinamax100: '#fcd0d0',
  redwinamax50: '#fee6e6',

  redinfo900: '#260D0D',
  redinfo200: '#F0A8A8',

  specialRed: '#ad8585',
  mmRadialRed: '#830711',
});

const blue = Object.freeze({
  // todo
  bluepastel: '#35befc', // toastr info. N'existe pas sur les maquettes.
  bluecaret: '#5398ff',

  blueinfo900: '#0D1326',
  blueinfo800: '#19264d',
  blueinfo350: '#55A6F6',
  blueinfo200: '#A8BAF0',
});

const others = Object.freeze({
  greyfooter: '#333',
  registermodalbackground: `linear-gradient(to bottom, ${red.red650} 0%, ${grey.bluegrey850} 66%)`,
});

const gradients = Object.freeze({
  menuburger: `linear-gradient(
    to right,
    ${grey.bluegrey700},
    ${grey.bluegrey850},
    ${grey.bluegrey850},
    ${grey.bluegrey850},
    ${grey.bluegrey925}
  )`,
  menuburgeractive: `linear-gradient(
    to right,
    ${grey.bluegrey700},
    ${grey.bluegrey850},
    ${grey.bluegrey925},
    ${grey.bluegrey925},
    ${grey.bluegrey925}
  )`,
  sports: `linear-gradient(to right, ${grey.bluegrey800} 0%, ${grey.bluegrey800} 50%, ${grey.bluegrey850} 75%, ${grey.bluegrey850} 100%)`,
  sportsactive: `linear-gradient(to right, #323645, ${grey.bluegrey800}, ${grey.bluegrey800})`,
  mymatch: `linear-gradient(to right, #2b2e38, #1d2028, ${grey.bluegrey850})`,
  boostedbage: `linear-gradient(236deg, #454853, ${grey.bluegrey850} 70%, ${grey.bluegrey925}),
  linear-gradient(236deg, #ffffff, #c0c5d9 47%, #dedfec)`,
  boostedoddheader: `linear-gradient(
    to right,
    #e5fdff,
    #c9dbff 50%,
    #a6a6d9 100%
  )`,
  boostedodd: `linear-gradient(
    to right,
    ${silver.silver75} 0%,
    ${silver.silver400} 8%,
    ${silver.silver600} 17%,
    #ffffff 33%,
    ${red.red200} 67%,
    ${red.red200} 100%
  )`,
  bigboostedodd: `linear-gradient(
    to right,
    ${gold.gold50} 0%,
    ${gold.gold150} 8%,
    ${gold.gold385} 17%,
    ${gold.gold250} 33%,
    ${red.red200} 67%,
    ${red.red200} 100%
  )`,
  bigboostedoddheader: `linear-gradient(
    to right,
    #ffbd29,
    #db9100 49%,
    #cb931a 60%,
    #ffefb7 100%
  )`,
  xmasboostedodd: `linear-gradient(
    to right,
    ${red.redwinamax350} 1%,
    ${red.redwinamax450} 7%,
    ${red.redwinamax400} 18%,
    ${red.redwinamax300} 33%,
    ${red.red200} 67%,
    ${red.red200} 100%
  )`,
  xmasboostedoddheader: `linear-gradient(
    to right,
    ${red.redwinamax350},
    ${red.redwinamax450} 33%,
    ${red.redwinamax400} 60%,
    ${red.redwinamax300} 100%
  )`,
  listitemodd: `linear-gradient(to right,
    ${grey.bluegrey700} 0%,
    ${grey.bluegrey700} 33%,
    ${grey.bluegrey850} 67%,
    ${grey.bluegrey850} 100%
  )`,
  listitemeven: `linear-gradient(to right,
    ${grey.bluegrey700} 0%,
    ${grey.bluegrey700} 33%,
    #2b2e38 67%,
    #1d2028,
    ${grey.bluegrey850} 100%
  )`,
  sublistitemodd: `linear-gradient(to right,
    ${grey.bluegrey700} 0%,
    ${grey.bluegrey700} 33%,
    ${grey.bluegrey800} 67%,
    ${grey.bluegrey800} 100%
  )`,
  sublistitemeven: `linear-gradient(to right,
    ${grey.bluegrey700} 0%,
    ${grey.bluegrey700} 33%,
    #2b2e38 67%,
    #1d2028,
    ${grey.bluegrey850} 100%
  )`,
  affiliationbuttonbackground: `linear-gradient(to right,
    ${grey.bluegrey850} 75%,
    ${grey.bluegrey800} 100%
  )`,
  affiliationbuttonborder: `linear-gradient(to bottom,
    ${grey.bluegrey700} 0%,
    rgba(67, 72, 90, 0) 55%
  )`,
  klbasketbetslipeligiblebg: `linear-gradient(to right,
    ${grey.neutralgrey450} 0%,
    ${grey.neutralgrey200} 15%,
    ${grey.neutralgrey100} 35%,
    ${grey.neutralgrey200} 100%
  )`,
  registermodalbackground: `linear-gradient(to bottom,
    ${red.red650} 0%,
    ${grey.bluegrey850} 66%
  )`,
  progressBarBackground: `linear-gradient(
    105deg,
    #2aa773 2%,
    #1d5a3c 27%,
    #46cc8a 65%,
    #c3ffe2 71%,
    #46cc8a 77%,
    #46cc8a 89%,
    #6dffb7 100%
  )`,
  missionEnrollmentButtonBorderGradient: `linear-gradient(
    to right,
    ${red.red200},
    ${red.red200} 33%,
    #2aa773 67%,
    #1d5a3c 75%,
    #46cc8a 88%,
    #c3ffe2 95%,
    #46cc8a 97%,
    #46cc8a 99%,
    #6dffb7 100%
  )`,
  missionEnrollmentButtonBorderHaloGradient: `linear-gradient(
    to right,
    ${red.red200},
    ${red.red200} 33%,
    transparent 67%
  )`,
  missionEnrollmentButtonBackgroundGradient: `linear-gradient(
    to right,
    ${red.red200},
    ${red.red200} 33%,
    #000000 67%,
    #000000 100%
  )`,
  missionsEligibleHeadbandbg: `linear-gradient(to right,
    ${grey.neutralgrey450} 0%,
    ${grey.neutralgrey200} 15%,
    ${grey.neutralgrey100} 35%,
    ${grey.neutralgrey200} 100%
  )`,
});

const colors = Object.freeze({
  transparent: 'transparent',
  black: '#000000',
  ...grey,
  ...silver,
  ...gold,
  ...gradients,
  ...green,
  ...yellow,
  ...orange,
  ...red,
  ...blue,
  ...others,
  white: '#ffffff',
});

export default colors;
